export default "__VITE_ASSET__73e73066__"